var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countryIDModel != null)?_c('v-select',{attrs:{"items":_vm.countries,"label":"Страна"},model:{value:(_vm.countryIDModel),callback:function ($$v) {_vm.countryIDModel=$$v},expression:"countryIDModel"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }